var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#004276"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4973 23.201C17.3985 23.201 17.3013 23.1766 17.2142 23.1301C17.1271 23.0835 17.0529 23.0161 16.9981 22.934L15.9763 21.401H14.7973C14.6381 21.401 14.4855 21.3378 14.373 21.2252C14.2605 21.1127 14.1973 20.9601 14.1973 20.801C14.1973 20.6419 14.2605 20.4892 14.373 20.3767C14.4855 20.2642 14.6381 20.201 14.7973 20.201H16.2973C16.4977 20.201 16.6849 20.3012 16.7965 20.468L17.4229 21.4076L18.7603 18.7322C18.8084 18.6361 18.8815 18.5548 18.9718 18.4966C19.0622 18.4384 19.1664 18.4055 19.2738 18.4013C19.3812 18.3972 19.4877 18.4219 19.5823 18.4729C19.6768 18.5239 19.756 18.5994 19.8115 18.6914L21.4369 21.401H22.5973C22.7564 21.401 22.909 21.4642 23.0215 21.5767C23.134 21.6892 23.1973 21.8419 23.1973 22.001C23.1973 22.1601 23.134 22.3127 23.0215 22.4252C22.909 22.5378 22.7564 22.601 22.5973 22.601H21.0973C20.9937 22.601 20.8919 22.5742 20.8018 22.5232C20.7117 22.4722 20.6363 22.3988 20.5831 22.31L19.3453 20.2472L18.0343 22.8698C17.9383 23.0612 17.7481 23.1872 17.5345 23.2004L17.4973 23.201Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1973 14.8008C15.8541 14.8008 17.1973 13.4576 17.1973 11.8008C17.1973 10.1439 15.8541 8.80078 14.1973 8.80078C12.5404 8.80078 11.1973 10.1439 11.1973 11.8008C11.1973 13.4576 12.5404 14.8008 14.1973 14.8008Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9969 20.801C12.9969 19.8086 13.8045 19.001 14.7969 19.001H16.2969C16.6083 19.001 16.9083 19.0808 17.1717 19.2272L17.6871 18.1958C17.9493 17.6732 18.4485 17.3306 19.0155 17.2394C18.7388 16.8566 18.3753 16.5449 17.955 16.3296C17.5346 16.1144 17.0692 16.0017 16.5969 16.001H11.7969C11.0012 16.001 10.2382 16.317 9.67555 16.8797C9.11295 17.4423 8.79688 18.2053 8.79688 19.001V20.951C8.79688 21.1994 8.99847 21.401 9.24687 21.401H13.1073C13.0362 21.2088 12.9989 21.0058 12.9969 20.801Z",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(8.79688 8.80078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon1);
export default __webpack_public_path__ + "static/media/dashboardicon1.a531f0a2307d61fd03ec828dc5e0d3d6.svg";
export { ForwardRef as ReactComponent };